import { render } from "./vdvclist.vue?vue&type=template&id=227ac8a8"
import script from "./vdvclist.vue?vue&type=script&lang=js"
export * from "./vdvclist.vue?vue&type=script&lang=js"

import "./vdvclist.vue?vue&type=style&index=0&id=227ac8a8&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__